import useAnimatedToggle, { WithConfig } from '@ui/hooks/useAnimatedToggle'
import { interpolate, useAnimatedStyle } from 'react-native-reanimated'

export const useAnimatedOpacity = (boolean: boolean, config?: WithConfig) => {
  const toggle = useAnimatedToggle(boolean, config)
  const style = useAnimatedStyle(() => {
    return {
      opacity: interpolate(toggle.value, [0, 1], [0, 1]),
      pointerEvents: toggle.value === 0 ? 'none' : 'auto',
    }
  })
  return style
}

export const useAnimatedOpacityOnly = (
  boolean: boolean,
  config?: WithConfig
) => {
  const toggle = useAnimatedToggle(boolean, config)
  const style = useAnimatedStyle(() => {
    return {
      opacity: interpolate(toggle.value, [0, 1], [0, 1]),
    }
  })
  return style
}
